import { tokenAPI } from "./axiosInstance";

// Add more product-related API calls here
export const getApiToken = (payload: { authorize: string }) =>
  tokenAPI.post("tk/token", payload, {
    headers: { "Content-Type": "application/json" },
  });

export const verifyApiToken = (token: string) =>
  tokenAPI.get("/tk/verify", {
    headers: { Authorization: `Bearer ${token}` },
  });
